import React, { useState } from "react";
import { Col, Form, Input, notification, Row } from "antd";
import s from "../../pages/Login/Login.module.scss";
import {
  CheckCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCountriesList, login } from "../../redux/AuthSlice";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getManagerEmployeesList,
  getManagersList,
  getMe,
} from "../../redux/UserSlice";
import {
  getAdminApplicationsList,
  getCountriesWithPosts,
  getManagersApplicationsList,
  setActiveTab,
  setManagersActiveTab,
} from "../../redux/ApplicationSlice";
import { useTranslation } from "react-i18next";
import Header from "../../pages/LandingPage/components/Header/LandingHeader";

import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import {
  setCurrentManagerPageNumber,
  setCurrentOtherManagerPageNumber,
} from "../../redux/ManagerSlice";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation();
  const token = useSelector((state: RootState) => state.auth.access);
  const { width } = useWindowDimensions();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const openNotification =
    (pauseOnHover: boolean, message: string, type: "success" | "error") =>
    () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  const loginUser = async (values: { email: string; password: string }) => {
    try {
      const res = await dispatch(
        login({
          email: values.email,
          password: values.password,
        }),
      );

      if (login.fulfilled.match(res) && res.payload.role === "broker") {
        dispatch(getMe());
        dispatch(setActiveTab("myApplications"));
        navigate("/brokersApplications");
      }

      if (login.fulfilled.match(res) && res.payload.role === "admin") {
        dispatch(getMe());
        await dispatch(getAdminApplicationsList(1));
        navigate("/admin/applications");
      }

      if (
        login.fulfilled.match(res) &&
        res.payload.role === "regional_manager"
      ) {
        dispatch(getMe());
        dispatch(setCurrentManagerPageNumber(1)); // ← Добавь
        dispatch(setCurrentOtherManagerPageNumber(1));
        await dispatch(getManagersApplicationsList(1));
        dispatch(setManagersActiveTab("myApplications"));
        navigate("/managerApplications");
      }

      if (login.fulfilled.match(res) && res.payload.role === "driver") {
        dispatch(getMe());
        navigate("/applications");
      }

      if (login.rejected.match(res)) {
        const errorMessage =
          res.payload && "error" in res.payload
            ? res.payload.error
            : "Произошла ошибка";

        openNotification(true, errorMessage, "error")();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div>
      {width > 500 ? <Header /> : <MobileLoginHeader />}
      <div className={s.login}>
        {contextHolder}
        <div className={s.logo_wrapper}>
          <img src="/logo.png" className={s.logo_img} />
          {/* <div className={s.logo}>MIDDLE CORRIDOR TRANSIT SYSTEM</div> */}
          <h2 className={s.h2}>{t("Log in to the DIGITAL TRANSIT HUB")}</h2>
        </div>
        <Form
          className={s.form}
          layout="vertical"
          form={form}
          onFinish={loginUser}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="email"
                label={t("Email")}
                rules={[
                  { required: true, message: t("Введите email") },
                  { type: "email", message: t("Укажите корректный email") },
                ]}
              >
                <input placeholder={t("Введите email")} className={s.input} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="password"
                label={t("Пароль")}
                rules={[{ required: true, message: t("Введите пароль") }]}
              >
                <Input
                  type={showPassword ? "text" : "password"}
                  suffix={
                    showPassword ? (
                      <EyeOutlined onClick={togglePasswordVisibility} />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={togglePasswordVisibility}
                      />
                    )
                  }
                  placeholder={t("Введите пароль")}
                  className={s.password_input}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className={s.row}>
            <Link to="/changePassword" className={s.forgetPassword}>
              {t("Забыли пароль?")}
            </Link>
          </div>
          <Row>
            <button className={s.enter_btn}>{t("Войти")}</button>
          </Row>
          <div className={s.no_account}>
            {t("Нет аккаунта?")} &nbsp;
            <Link
              to="/register"
              className={s.register_btn}
              onClick={() => {
                dispatch(getManagersList());
                dispatch(getCountriesList());
              }}
            >
              {t("Зарегистрироваться")}
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
